import { styled } from '@olxeu-jobs/ui';

export const Picture = styled('picture', {
  position: 'relative',
  display: 'flex',
  overflow: 'hidden',
});

export const Image = styled('img', {
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'inherit',
});

export const LoQualityImageWrapper = styled<'div', { $visible: boolean }>(
  'div',
  ({ $visible, $theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: $visible ? 1 : 0,
    objectFit: 'inherit',
    transition: `opacity ${$theme.animation.duration[150]}`,
    filter: 'blur(2px)',
  }),
);
